import axios from '../../axios/index.js'
import store from '../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  getRestaurantListAll (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/restaurantListAll', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getRestaurantList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/restaurantList', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getCateringRestaurantList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/cateringRestaurantList', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getRestaurantListAllRestaurants () {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/restaurantListAllRestaurants', {
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getClosedRestaurantList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/restaurantList', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getHomeRestaurantList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/homeRestaurantList', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getAreaList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/listArea', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getAreaListAll (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/listAreaAll', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getAreaRestaurantList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/areaRestaurantList', {
      params: payload,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  },
  getRestaurant (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/getRestaurant', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getRestaurantByEmail (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/getRestaurantByEmail', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getOrder (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/order/getOrder', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCoupon (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/order/getCoupon', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getGift (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/order/getGift', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCateringData (payload) {
    return axios.get(`/api/customer/catering/offer/${payload.cateringOrderOfferId}/${payload.offerToken}`)
  },
  sendRestaurantOffer (payload) {
    return axios.post(`/api/customer/catering/offer/${payload.cateringOrderOfferId}/${payload.offerToken}`, payload)
  },
  getDeliveryMethod (payload) {

    const token = localStorage.accessToken
    return axios.get(`/api/customer/order/delivery-methods/${payload.restaurantId}`, {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getSearchData (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/search', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getSearchRestaurantData (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/search', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getProductList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/productList', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getCateringProductList (payload) {

    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant/cateringProductList', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getProduct (payload) {
    return axios.get('/api/customer/restaurant/getProduct', {
      params: payload
    })
  },
  getUser () {
    const token = localStorage.accessToken
    return axios.get('/api/customer/user/getUser', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  loginUser (payload) {
    return axios.post('/api/auth/login', payload)
  },
  verifyMail (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/user/verify-new-email', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  changePassword (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/user/changePassword', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  registerUser (payload) {
    return axios.post('/api/customer/register', payload)
  },
  claimBusiness (payload) {
    return axios.post('/api/customer/claimBusiness', payload)
  },
  forgotPassword (payload) {
    return axios.post('/api/customer/user/forgotPassword', payload)
  },
  resetPassword (payload) {
    return axios.post('/api/customer/user/resetPassword', payload)
  },
  getUserProperty () {
    const token = localStorage.accessToken
    return axios.get('/api/customer/user/propertyList', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getAddressList () {
    const token = localStorage.accessToken
    return axios.get('/api/customer/user/addressList', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getAddress (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/user/getAddress', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  saveAddress (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/user/addressSave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  saveUser (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/user/userSave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  uploadImage (payload, onUploadProgress) {
    const token = localStorage.accessToken
    const formData = new FormData()

    formData.append('file', payload.file)

    return axios.post('/api/customer/user/profileImageSave', formData, {
      headers:{
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress
    })
  },
  deleteAddress (payload) {
    const token = localStorage.accessToken
    return axios.delete('/api/customer/user/deleteAddress', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  saveOrder (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/order/orderSave', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  orderCheck (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/order/order-check', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getDeliveryFee (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/order/delivery-fee', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  saveOffer (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/catering', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  checkToken (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/auth/loginCheck', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getOrderList () {
    const token = localStorage.accessToken
    return axios.get('/api/customer/order/orderList', {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  eventList (payload) {
    return axios.get('/api/event/eventList', {
      params: payload
    })
  },
  liveCities (payload) {
    return axios.get('/api/customer/live-cities', {
      params: payload
    })
  },
  getAreaText (payload) {
    return axios.get('/api/customer/getArea', {
      params: payload
    })
  },
  getContentList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/content/contentList', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  getCampaignList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/content/campaignList', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  getCouponList (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/couponListAll', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  getContent (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/content/getContent', {
      headers:{
        Authorization: `Bearer ${token}`
      },
      params: payload
    })
  },
  getPiSecret (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/order/payment_intent', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  sendContact (payload) {
    return axios.post('/api/customer/contact', payload)
  },
  sendRestaurantSale (payload) {
    return axios.post('/api/customer/restaurant-sales/send', payload)
  },
  getGiftCards (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/gift-cards', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  setGiftCards (payload) {
    const token = localStorage.accessToken
    return axios.post('/api/customer/gift-cards', payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getRestaurantSales (payload) {
    const token = localStorage.accessToken
    return axios.get('/api/customer/restaurant-sales', {
      params: payload,
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getRestaurantSale (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/customer/restaurant-sales/${payload.restaurantSaleId}`, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  getReviews (payload) {
    const token = localStorage.accessToken
    return axios.get(`/api/customer/reviews/${payload.restaurantId}`, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  },
  sendRestaurantReview (payload) {
    const token = localStorage.accessToken
    return axios.post(`/api/customer/reviews/${payload.restaurant_id}`, payload, {
      headers:{
        Authorization: `Bearer ${token}`
      }
    })
  }
}
